import React, { useState } from 'react';
import InputForm from '../../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, CircularProgress, TextField, Typography } from '@mui/material';
import { Button, Input, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Clear, DataArray, MonetizationOn, MonetizationOnOutlined, Money, Phone, SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import SearchInput from '../../../SearchInput';
import CheckBox from '../../../CheckBox';
import SearchModal from '../../../SearchModal';
import RadioBox from '../../../Radiox';
import TextArea from 'antd/es/input/TextArea';
import Datas from "../../../../Data/Data.json"
import { Crypter } from '../../../../Functions/Security/Crypter';
import axios from 'axios';
import DataTypeTable from '../../../../Types/DataTypeTable';
import SweetAlert from "sweetalert2"
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Data from '../../../../Data/Data.json'
import { DownOutlined } from '@ant-design/icons';


let searchUser: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }


let searchTypAdr: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }
let searchPretForm: Params = { CodeAgence: '', Table: "PRETS", Colonne1: "NUMDOS", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }



//Initialisation des parametres de recherche
let searchTitre: Params = { CodeAgence: '', Table: "TITRES", Colonne1: "CDTITR", Colonne2: "LIBELL1", Colagence: '101', Choix: 22 }
let searchSituationFamiliale: Params = { CodeAgence: "SITFAM", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
let searchProspect: Params = { CodeAgence: '', Table: "DEMARC", Colonne1: "CODDMR", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchClassRisque: Params = { CodeAgence: '', Table: "CLARIS", Colonne1: "CLARIS", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchPays: Params = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchActivite: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchUniteInstitutionnel: Params = { CodeAgence: '', Table: "TABNUI", Colonne1: "CODNUI", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchRegimeMatrimonial: Params = { CodeAgence: "REGMAT", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
//
let searchNiveauInstruction: Params = { CodeAgence: '', Table: "INSTRU", Colonne1: "CODINS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchEthnie: Params = { CodeAgence: '', Table: "ETHNIE", Colonne1: "CODETH", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchCateGo: Params = { CodeAgence: '', Table: "CATEGO", Colonne1: "CATEGO", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchZoneGeo: Params = { CodeAgence: '', Table: "RESIDE", Colonne1: "CDRESI", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchAgence: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGroup: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchService: Params = { CodeAgence: '', Table: "SERVICE", Colonne1: "CODSERV", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchCompte: Params = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }
let searchStatus: Params = { CodeAgence: '', Table: "Status", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchPlanCpte: Params = { CodeAgence: '', Table: "V_COMPTE_CLIENTELE_PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchPeriod: Params = { CodeAgence: '', Table: "v_period_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypeAmort: Params = { CodeAgence: '', Table: "v_typeAmortissement_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypeCalcul: Params = { CodeAgence: '', Table: "v_typeCalcul_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypePret: Params = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchNature: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchMotif: Params = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchSimul: Params = { CodeAgence: '', Table: "SIMULPRET", Colonne1: "NUMSIMUL", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }

interface SelectData {
  value: string,
  label: string,
}

function Tab1(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const [numcli, setNumcli] = useState("")
  const [numcpt, setNumcpt] = useState("")
  const [competClients, SetCompetClients] = React.useState<SelectData[]>([]);
  const [loading, setLoading] = useState(false)
  const [loadCompte, setLoadCompte] = useState(false)
  const [numcptEpargne, setNumcptEpargne] = useState("")


  // USER TOKEN
  const authHeader = useAuthHeader()

  let searchCompte: Params = { CodeAgence: '', Table: "CCOMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Init: numcli, Colagence: '101', Choix: 22 }


  function loadGarantie() {
    localStorage.setItem("garanties_client", "")
    localStorage.setItem(Datas.LocalVariable.garantie, "")
    try {
      let numcli = props.form.getFieldValue("NUMCLI")
      numcli += Datas.LocalVariable.separator + "CL"

      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.GetGarantie,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(numcli))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;


            if (res.StatutCode == 200) {
              let datas = res.Result.Table;

              //alert(datas.length)
              if (datas.length === 0) {
                localStorage.setItem("garanties_client", "")
              }
              else {
                localStorage.setItem("garanties_client", Crypter.encrypt(JSON.stringify(datas)))
              }
            }
          }

        }).catch((error) => {
          localStorage.setItem("garanties_client", "")
          SweetAlert.fire({ title: "Error", text: error })
        })
    } catch (error) {
      SweetAlert.fire({ title: "Veillez sélectionnez le client donc vous voulez charger les garantie", icon: "warning" })
      localStorage.setItem("garanties_client", "")
    }
  }

  function loadAvaliste() {
    localStorage.setItem("avalistes_client", "")
    localStorage.setItem(Datas.LocalVariable.garantie, "")
    try {
      let numcli = props.form.getFieldValue("NUMCLI")
      //numcli += Datas.LocalVariable.separator + "CL"
      //alert(numcli)
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.GetRelation,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherNumcli': Crypter.encrypt(JSON.stringify(numcli))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));


            if (res.StatutCode == 200) {
              let datas = res.Result.Table;

              //alert(datas.length)
              if (datas.length === 0) {
                localStorage.setItem("avalistes_client", "")
              }
              else {
                localStorage.setItem("avalistes_client", Crypter.encrypt(JSON.stringify(datas)))
              }
            }
          }

        }).catch((error) => {
          localStorage.setItem("avalistes_client", "")
          SweetAlert.fire({ title: "Error", text: error })
        })
    } catch (error) {
      SweetAlert.fire({ title: "Veillez sélectionnez le client donc vous voulez charger les garantie", icon: "warning" })
      localStorage.setItem("avalistes_client", "")
    }
  }

  function loadClientCompte() {
    setLoadCompte(true)
    SetCompetClients([])
    setNumcpt("")
    let numcli = props.form.getFieldValue("NUMCLI")
    //alert(numcli)
    if (numcli != "") {
      let searchClientComptes: Params = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NUMCLI", Init: numcli, Colagence: '101', Choix: 22 }

      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.AnySearch,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(searchClientComptes))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;


            //alert(JSON.stringify(res))
            if (res.StatutCode == 200) {
              let datas = res.Result.Table;
              //alert(JSON.stringify(datas))

              //alert(datas.length)
              if (datas.length === 0) {
                SweetAlert.fire({ title: "This client don't have accounts", icon: "warning" })
              }
              else {
                const datat: SelectData[] = [];
                datas.map((data: any) => {
                  //console.log(JSON.stringify(data))
                  datat.push({
                    value: data.NUMCPT,
                    label: data.NUMCPT,
                  });
                  SetCompetClients(datat);
                })
                //alert(JSON.stringify(datat))
              }
            }
          }
          setLoadCompte(false)
        }).catch((error) => {
          setLoadCompte(false)
          SweetAlert.fire({ title: "Error", text: error })
        })

    }
  }

  setTimeout(() => {
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      let compte = props.form.getFieldValue("CPTORDI")
      let compteEpargne = props.form.getFieldValue("CPTEPARG")

      setNumcpt(compte)
      setNumcptEpargne(compteEpargne)
      if (reset == "1") {
        setNumcli("")
        setNumcpt("")
        setNumcptEpargne("")
        SetCompetClients([])
      }
      localStorage.removeItem(Data.LocalVariable.reset)
    }
    catch (error) {
      console.log(error)
    }

    try {
      let isOkay = localStorage.getItem("load_compte")
      if (isOkay == "1") {
        loadClientCompte()
      }
      localStorage.removeItem("load_compte")
    } catch (error) {

    }
  },  1);

  function handleClientChange() {
    loadClientCompte()
    loadGarantie()
    loadAvaliste()
  }

  const handleChangeGompte = (value: string) => {
    //alert("zzz")
    setNumcpt(value);
    props.form.setFieldValue("CPTORDI", value)
  };
  const handleChangeGompteEpargne = (value: string) => {
    setNumcptEpargne(value);
    props.form.setFieldValue("CPTEPARG", value)
  };

  function load() {
    localStorage.setItem(Data.LocalVariable.reset, "1")
    //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
    let data = Crypter.encrypt(props.form.getFieldValue("NUMSIMUL"));
    let NUMSIMUL = props.form.getFieldValue("NUMSIMUL")

    if (data.length != 0) {
      setLoading(true)
      props.form.resetFields()
      props.form.setFieldValue('NUMSIMUL', NUMSIMUL)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetSimulationPret,
        headers: {
          'CypherNumSimul': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            console.log(res)
            if (res.StatutCode == 200) {
              props.form.setFieldsValue(res.Result.Table[0])
              props.form.setFieldValue('DATEDEM', ReformatDate(res.Result.Table[0].DATEDEM));
              props.form.setFieldValue('DAT1ECHE', ReformatDate(res.Result.Table[0].DAT1ECHE));
              //alert(props.form.getFieldValue("NUMCLI"))

              handleClientChange()
            }
            else {
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          SweetAlert.fire({ title: error, icon: "error" })
        });
    }
  }

  return (
    <div className='tabItemAuto'>
      <div >
        <Box display={'flex'} fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
          <Box fontStyle="inherit" className='border-left'>
            {/* <SearchModal   width={9} form = {props.form}  Titre='Recherche Utilisateur'  label='Code' name='coduti' Parametre={searchUser}/> */}
            <InputForm disabled notRequired width={9} label='Numéro Demande' name='NUMDOS' type={'text'} />
            <SearchModal disabled handleFunction={handleClientChange} width={9} form={props.form} Titre="Recherche Indice client" label='Indice client' name='NUMCLI' Parametre={searchIndice} />


            <Box fontStyle={'inherit'} display={'flex'}>

              <Box margin={1} fontStyle={'inherit'}>
                <label htmlFor="">Cpt remboussement  </label>
                <Select

                  loading={false}
                  onChange={handleChangeGompte}
                  value={numcpt}
                  id='codage'
                  size='middle'
                  style={{ width: "100%" }}
                  options={competClients}

                  suffixIcon={loadCompte ? <CircularProgress size={"20px"} /> : <DownOutlined />}
                />
              </Box>
              <Box margin={1} fontStyle={'inherit'}>
                <label htmlFor="">Compte de l'épargne  </label>
                <Select

                  loading={false}
                  onChange={handleChangeGompteEpargne}
                  value={numcptEpargne}
                  id='codage'
                  size='middle'
                  style={{ width: "100%" }}
                  options={competClients}
                  suffixIcon={loadCompte ? <CircularProgress size={"20px"} /> : <DownOutlined />}
                />
              </Box>
            </Box>

            <SearchModal notRequired width={9} form={props.form} Titre="Recherche Type de pret" label='Type de pret' name='TYPEPRET' Parametre={searchTypePret} />
            <SearchModal width={9} form={props.form} Titre="Recherche Gestionnaire" label='Gestionnaire' name='CODGES' Parametre={searchGes} />
            <SearchModal width={9} form={props.form} Titre="Recherche Motif Pret" label='Motif demande' name='MOTIFDEM' Parametre={searchMotif} />
            <InputForm defaultValue={user.datjour} width={9} label='Date Demande' icon={<SwipeUp color='disabled' fontSize='small' />} name='DATEDEM' type='date' error='mobile' />
          </Box>

          <Box fontStyle="inherit" className='border-left'>
            <InputForm width={9} label='Montant Validé' icon={<MonetizationOnOutlined fontSize='small' />} name='MONTAN' type='number' error='mobile' />
            <InputForm width={9} label='Taux Intéret' icon={<MonetizationOnOutlined fontSize='small' />} name='TAUXINT' type='number' error='mobile' />
            <InputForm width={9} label='Taux Taxe' icon={<MonetizationOnOutlined fontSize='small' />} name='TAUXTAX' type='number' error='mobile' />
            <InputForm width={9} label='Nbre échéance' icon={<MonetizationOnOutlined fontSize='small' />} name='NBRECHE' type='number' error='mobile' />
            <InputForm width={9} label='Nbre Pde diféré' icon={<MonetizationOnOutlined fontSize='small' />} name='NBPERDIF' type='number' error='mobile' />
            <SearchModal width={9} form={props.form} Titre="Recherche Périodicité" label='Périodicité' name='PERIODIC' Parametre={searchPeriod} />
            <InputForm width={9} label='Dte 1ère Ech' icon={<MonetizationOnOutlined fontSize='small' />} name='DAT1ECHE' type='date' error='mobile' />
            <SearchModal width={9} form={props.form} Titre='Recherche Type Calcul' label='Type Calcul' name='TYPCALC' Parametre={searchTypeCalcul} />
          </Box>
          <Box fontStyle="inherit" className='border-left'>
            <SearchModal width={9} form={props.form} Titre="Recherche Secteur d'activité" label='S. activité' name='CODNAE' Parametre={searchNature} />
            <SearchModal width={9} form={props.form} Titre="Recherche Type Amortissement" label='Type Amort' name='TYPAMORT' Parametre={searchTypeAmort} />
            <InputForm width={9} label='Taux épargne' icon={<MonetizationOnOutlined fontSize='small' />} name='TAUXEPAR' type='number' error='mobile' />
            <InputForm width={9} label='Montant Epargne' icon={<MonetizationOnOutlined fontSize='small' />} name='MONTEPARG' type='number' error='mobile' />
            <InputForm width={9} label='Frais service' icon={<MonetizationOnOutlined fontSize='small' />} name='fraiservi' type='number' error='mobile' />
            <InputForm width={9} label='Taux pénalité' icon={<MonetizationOnOutlined fontSize='small' />} name='TAUXPEN' type='number' error='mobile' />
            <InputForm disabled width={9} label='Commentaire' icon={<SwipeUp color='disabled' fontSize='small' />} name='COMMENT' type='TextArea' error='mobile' />

          </Box>
        </Box>
      </div>
    </div>

  )
}

export default Tab1;